// @flow
import type { CohortDriver } from 'types/entities';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { cohortDriverUpdate } from 'actions/cohorts';

import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';
import DriverForm from 'components/entities/DriverForm';

type Props = {
  cohortID: string,
  driverID: string,
  driver: CohortDriver,
  cohortDriverUpdate: Function,

  handleClose: Function,
  showModal: boolean,
};

@withEscapeToDismiss()
export class DriverEditModal extends Component {
  hideModal: Function;
  form: Object;
  props: Props;

  render() {
    return (
      <div
        className={classnames('modal', {
          'is-active': this.props.showModal,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-content">
          <div className="modal-box">
            <button
              aria-label="Close modal"
              className="is-pulled-right delete"
              onClick={() => {
                this.props.handleClose();
              }}
            />
            <h1 className="title">
              Edit Driver
            </h1>
            <hr />
            <DriverForm
              defaultValue={this.props.driver}
              disableLoginFields
              ref={(input) => { this.form = input; }}
            />
            <hr />
            <div className="field is-grouped has-text-right">
              <p className="control">
                <button
                  className="button is-outlined"
                  onClick={() => {
                    this.props.handleClose();
                  }}
                >
                  Cancel
                </button>
              </p>
              <p className="control">
                <button
                  className="button is-primary"
                  onClick={() => {
                    const driver: CohortDriver = this.form.getValue();
                    this.props.cohortDriverUpdate(this.props.cohortID,
                      this.props.driverID, driver);
                    this.props.handleClose();
                  }}
                >
                  Update
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DriverEditModal.contextTypes = {
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    driver: state.cohorts[ownProps.cohortID].drivers[ownProps.driverID],
  };
}

export default connect(
  mapStateToProps,
  {
    cohortDriverUpdate,
  }
)(DriverEditModal);



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/drivers/DriverEditModal.jsx
 **/